import React from "react";
import Seo from "../components/seo";
import Layout from "../components/layout";
import SectionNav from "../components/newComponents/sectionNav";
import SectionHead from "../components/newComponents/sectionHead";
import Card from "../components/newComponents/card";
import GeneralSection from "../components/newComponents/generalSection";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { HandleQuery, WhatWeDoProjectsData } from "../queries";

export function WhatWeDoProjectsEntry()
{

    let { slug } = useParams();

    const query_state = useQuery(WhatWeDoProjectsData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 


  const projects = data.relatedFocusAreaProjects.concat(data.relatedAreaOfExpertiseProjects)
  let uniqueProjects = [];
  let projectIds = [];
    
  for(let project of projects) {
    
    if(projectIds.indexOf(project.id) === -1) {

      uniqueProjects.push(project);
      projectIds.push(project.id);
    }
  }

  uniqueProjects.sort(function(a, b) {
    return new Date(b.postDate).getTime() - new Date(a.postDate).getTime();
  });

  return (
    <Layout>
      <Seo title={data.entry.title} />
      <div className="main">
        <SectionNav data={data} base={`/what-we-do/${slug}`} currentUri={`/what-we-do/${slug}/projects`}/>
        <GeneralSection className="section-overview" style={{paddingBottom: 0}}>
          <SectionHead title={data.entry.title} subtitle={"All projects"}/>
        </GeneralSection>
        {uniqueProjects.length > 0 ?
          <GeneralSection className="section-listing section-listing--secondary js-section-listing" style={{paddingTop: 0}}>
            <div className="boxes swiper-container js-slider-boxes-projects">
              <ul>
                {uniqueProjects.map((item, i) => (
                  <Card key={`what-we-do-projects-entry-${i}`} image={item.featureImage[0]} title={item.title} subtitle={item.summary} href={`/${item.uri}`} color={1}/>
                ))}
              </ul>
            </div>
          </GeneralSection>
          :
          <></>
        }
      </div>
    </Layout>
  );
};
